module.exports = __webpack_public_path__ + "img/search-by-algolia.a04d174f.svg";